<template>
  <div>
    <v-btn
      class="btn-add"
      @click.native.stop="versionBlockDialog(id, true)"
      :title="label"
    >
      <i :class="iconClass"></i>{{ btnLabel }}
    </v-btn>
    <v-dialog v-model="showDialog[id]" max-width="800">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t("Управление блоком") }}
          <v-btn color="modal-close" @click="versionBlockDialog(id, false)">
            <span class="pro-icon-close1"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <v-row>
            <v-col cols="12" sm="12">
              <div class="form-group npa-editor">
                <ckeditor
                  v-model="editorData"
                  :editor="editor"
                  :config="editorConfig"
                  @ready="prefill(blockValue)"
                  @change="prefill(editorData)"
                />
              </div>
              <div class="form-group">
                <div class="checkbox">
                  <label>
                    <input
                      type="checkbox"
                      v-model="commented"
                      value="1"
                    />Комментировать
                  </label>
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="12">
              <v-btn color="primary" dark @click="setDataBlock(id)">
                {{ $t("Сохранить") }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// ckeditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice'
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily'
import Font from '@ckeditor/ckeditor5-font/src/font'
export default {
  props: {
    type: String,
    versionId: Number,
    blockId: Number,
    id: String,
    lang: String,
    blockValue: String,
    label: String,
    btnLabel: String,
    iconClass: String,
    blockCommented: Boolean
  },
  data: () => ({
    showDialog: {},
    sendDataBlock: {},
    editor: ClassicEditor,
    editorData: '',
    commented: true,
    editorConfig: {
      plugins: [
        EssentialsPlugin,
        BoldPlugin,
        ItalicPlugin,
        LinkPlugin,
        ParagraphPlugin,
        HeadingPlugin,
        Alignment,
        Table,
        TableToolbar,
        PasteFromOffice,
        FontFamily,
        Font
      ],
      toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'alignment',
        '|',
        'undo',
        'redo',
        '|',
        'insertTable',
        'fontFamily', 'fontSize',
      ],
      fontFamily: {
        options: [
          'default',
          'Times New Roman, Times, serif',
          'Arial, Helvetica, sans-serif',
          'Courier New, Courier, monospace'
        ]
      },
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
      },
      heading: {
        options: [
          {
            model: 'paragraph',
            title: 'Paragraph',
            class: 'ck-heading_paragraph'
          },
          {
            model: 'heading1',
            view: 'h1',
            title: 'Heading 1',
            class: 'ck-heading_heading1'
          },
          {
            model: 'heading2',
            view: 'h2',
            title: 'Heading 2',
            class: 'ck-heading_heading2'
          },
          {
            model: 'heading3',
            view: 'h3',
            title: 'Heading 3',
            class: 'ck-heading_heading3'
          }
        ]
      }
    }
  }),
  mounted() {
    this.commented = this.blockCommented
  },
  methods: {
    versionBlockDialog(id, flag) {
      this.$set(this.showDialog, id, flag)
    },
    prefill(val) {
      this.editorData = val
    },
    setDataBlock(id) {
      let routeParam = '?' + this.type + '&lang=' + this.lang
      if (this.type == 'before') {
        routeParam = '?' + this.type + '=' + this.blockId + '&lang=' + this.lang
      }
      this.sendDataBlock = {
        routeParam: routeParam,
        text: this.editorData,
        versionId: this.versionId,
        blockId: this.blockId,
        lang: this.lang,
        type: this.type,
        commented: this.commented
      }
      this.$emit('setDataBlock', this.sendDataBlock)
      this.versionBlockDialog(id, false)
    }
  }
}
</script>
